import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { ArrowRight, Award, HeartHandshake, Shield } from "lucide-react";

export default function About() {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="about-page">
      <SEO
        title="À propos"
        description="Découvrez l'histoire de DAS SIMAO AUTO, entreprise française de convoyage et VTC premium fondée par Arnaud Simao."
      />
      <Header />
      <section className="pt-32 pb-16 max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-xs tracking-[0.5em] gold uppercase">Notre histoire</div>
        <h1 className="mt-3 font-serif text-white text-5xl sm:text-6xl leading-tight">
          Le service premium,<br />sans compromis.
        </h1>
        <p className="mt-8 text-lg text-gray-300 leading-relaxed">
          DAS SIMAO AUTO est né d'une conviction simple : le transport
          d'un véhicule et le trajet d'un passager méritent la même exigence
          — celle du soin, de la ponctualité et de la discrétion. Fondée et
          dirigée par <b className="gold">Arnaud Simao</b>, l'entreprise
          intervient partout en France pour convoyer voitures et raccompagner
          particuliers comme professionnels.
        </p>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {[
            { icon: Shield, title: "Rigueur", text: "Chaque prestation est validée personnellement avant d'être confirmée." },
            { icon: HeartHandshake, title: "Proximité", text: "Interlocuteur unique, joignable directement — pas de call-center." },
            { icon: Award, title: "Excellence", text: "Véhicules premium, chauffeurs certifiés, assurance en tous risques." },
          ].map(({ icon: Icon, title, text }) => (
            <div key={title} className="p-6 border border-white/10 bg-[#0a0a0a]">
              <Icon size={22} className="gold mb-3" />
              <div className="font-serif text-xl text-white">{title}</div>
              <p className="mt-1 text-sm text-gray-400">{text}</p>
            </div>
          ))}
        </div>

        <div className="mt-20 p-10 border border-[color:var(--gold)]/30 bg-gradient-to-br from-[#131007] to-[#0a0a0a]">
          <div className="text-xs tracking-[0.5em] gold uppercase">Le mot du gérant</div>
          <blockquote className="mt-4 font-serif text-2xl sm:text-3xl text-white leading-snug">
            "Chaque client mérite un service à sa hauteur. Je suis là pour
            m'en assurer, personnellement."
          </blockquote>
          <div className="mt-6 text-gray-400">— Arnaud Simao, fondateur & gérant</div>
        </div>

        <div className="mt-16 text-center">
          <Link to="/convoyage" className="btn-gold inline-flex items-center gap-2" data-testid="about-cta">
            Réserver une prestation <ArrowRight size={16} />
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
